import getSelectedTableViewId from './getSelectedTableViewId';
import TableView from '../store/schema/TableView';
import { getListViewStore } from '../store/Store';

export default function getCurrentSelectedTableView(): TableView {
    const currentTableViewId = getSelectedTableViewId();

    return currentTableViewId ? getListViewStore().tableViews.get(currentTableViewId) : null;
}
